//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';


@Injectable()
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject('API_BASE') baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:57809";
    }

    getUserInfo(): Observable<UserDto | null> {
        let url_ = this.baseUrl + "/user/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto | null>;
        }));
    }

    protected processGetUserInfo(response: HttpResponseBase): Observable<UserDto | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserPermissions(fxn: string | null): Observable<UserPermissions> {
        let url_ = this.baseUrl + "/user/user-function-permissions?";
        if (fxn === undefined)
            throw new Error("The parameter 'fxn' must be defined.");
        else if(fxn !== null)
            url_ += "fxn=" + encodeURIComponent("" + fxn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPermissions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPermissions>;
        }));
    }

    protected processGetUserPermissions(response: HttpResponseBase): Observable<UserPermissions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissions.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMainMenu(): Observable<MainMenuOption[] | null> {
        let url_ = this.baseUrl + "/user/user-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MainMenuOption[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MainMenuOption[] | null>;
        }));
    }

    protected processGetMainMenu(response: HttpResponseBase): Observable<MainMenuOption[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MainMenuOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserHeaderInfo(): Observable<UserHeaderInfo | null> {
        let url_ = this.baseUrl + "/user/user-header";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserHeaderInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserHeaderInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserHeaderInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserHeaderInfo | null>;
        }));
    }

    protected processGetUserHeaderInfo(response: HttpResponseBase): Observable<UserHeaderInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserHeaderInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMainMenuDiaryCounts(dayInMonth: Date): Observable<DiaryCalendarCount[] | null> {
        let url_ = this.baseUrl + "/user/user-menu-diary-counts?";
        if (dayInMonth === undefined || dayInMonth === null)
            throw new Error("The parameter 'dayInMonth' must be defined and cannot be null.");
        else
            url_ += "dayInMonth=" + encodeURIComponent(dayInMonth ? "" + dayInMonth.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainMenuDiaryCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainMenuDiaryCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiaryCalendarCount[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiaryCalendarCount[] | null>;
        }));
    }

    protected processGetMainMenuDiaryCounts(response: HttpResponseBase): Observable<DiaryCalendarCount[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiaryCalendarCount.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSystemMessages(): Observable<string | null> {
        let url_ = this.baseUrl + "/user/user-system-messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetSystemMessages(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHomeScreenPreference(): Observable<string | null> {
        let url_ = this.baseUrl + "/user/user-home-screen-preference";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeScreenPreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeScreenPreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetHomeScreenPreference(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logUserViewFunctionActivity(menuFunctionCode: string | null, claimNumber: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/user/log-user-view-activity?";
        if (menuFunctionCode === undefined)
            throw new Error("The parameter 'menuFunctionCode' must be defined.");
        else if(menuFunctionCode !== null)
            url_ += "menuFunctionCode=" + encodeURIComponent("" + menuFunctionCode) + "&";
        if (claimNumber !== undefined && claimNumber !== null)
            url_ += "claimNumber=" + encodeURIComponent("" + claimNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogUserViewFunctionActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogUserViewFunctionActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogUserViewFunctionActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUserCurrentSessionData(model: SharedSessionModel | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/user/delete-user-current-session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserCurrentSessionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserCurrentSessionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteUserCurrentSessionData(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserDto implements IUserDto {
    userId?: string | undefined;
    userRealName?: string | undefined;
    teamCode?: string | undefined;
    language?: string | undefined;
    isTeamLeader!: boolean;
    profileImage?: string | undefined;
    userEmail?: string | undefined;
    userPhoneNumber?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.userRealName = _data["UserRealName"];
            this.teamCode = _data["TeamCode"];
            this.language = _data["Language"];
            this.isTeamLeader = _data["IsTeamLeader"];
            this.profileImage = _data["ProfileImage"];
            this.userEmail = _data["UserEmail"];
            this.userPhoneNumber = _data["UserPhoneNumber"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["UserRealName"] = this.userRealName;
        data["TeamCode"] = this.teamCode;
        data["Language"] = this.language;
        data["IsTeamLeader"] = this.isTeamLeader;
        data["ProfileImage"] = this.profileImage;
        data["UserEmail"] = this.userEmail;
        data["UserPhoneNumber"] = this.userPhoneNumber;
        return data;
    }
}

export interface IUserDto {
    userId?: string | undefined;
    userRealName?: string | undefined;
    teamCode?: string | undefined;
    language?: string | undefined;
    isTeamLeader: boolean;
    profileImage?: string | undefined;
    userEmail?: string | undefined;
    userPhoneNumber?: string | undefined;
}

export class UserPermissions implements IUserPermissions {
    canView!: boolean;
    canInsert!: boolean;
    canDelete!: boolean;
    canEdit!: boolean;

    constructor(data?: IUserPermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canView = _data["CanView"];
            this.canInsert = _data["CanInsert"];
            this.canDelete = _data["CanDelete"];
            this.canEdit = _data["CanEdit"];
        }
    }

    static fromJS(data: any): UserPermissions {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CanView"] = this.canView;
        data["CanInsert"] = this.canInsert;
        data["CanDelete"] = this.canDelete;
        data["CanEdit"] = this.canEdit;
        return data;
    }
}

export interface IUserPermissions {
    canView: boolean;
    canInsert: boolean;
    canDelete: boolean;
    canEdit: boolean;
}

export class MainMenuOption implements IMainMenuOption {
    title?: string | undefined;
    fxn?: string | undefined;
    order?: number | undefined;
    children?: MainMenuOption[] | undefined;

    constructor(data?: IMainMenuOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.fxn = _data["Fxn"];
            this.order = _data["Order"];
            if (Array.isArray(_data["Children"])) {
                this.children = [] as any;
                for (let item of _data["Children"])
                    this.children!.push(MainMenuOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MainMenuOption {
        data = typeof data === 'object' ? data : {};
        let result = new MainMenuOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Fxn"] = this.fxn;
        data["Order"] = this.order;
        if (Array.isArray(this.children)) {
            data["Children"] = [];
            for (let item of this.children)
                data["Children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMainMenuOption {
    title?: string | undefined;
    fxn?: string | undefined;
    order?: number | undefined;
    children?: MainMenuOption[] | undefined;
}

export class UserHeaderInfo implements IUserHeaderInfo {
    userRealName?: string | undefined;
    userProfileImagePath?: string | undefined;
    sidebarMenuBehaviorPreference?: string | undefined;

    constructor(data?: IUserHeaderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userRealName = _data["UserRealName"];
            this.userProfileImagePath = _data["UserProfileImagePath"];
            this.sidebarMenuBehaviorPreference = _data["SidebarMenuBehaviorPreference"];
        }
    }

    static fromJS(data: any): UserHeaderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserHeaderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserRealName"] = this.userRealName;
        data["UserProfileImagePath"] = this.userProfileImagePath;
        data["SidebarMenuBehaviorPreference"] = this.sidebarMenuBehaviorPreference;
        return data;
    }
}

export interface IUserHeaderInfo {
    userRealName?: string | undefined;
    userProfileImagePath?: string | undefined;
    sidebarMenuBehaviorPreference?: string | undefined;
}

export class DiaryCalendarCount implements IDiaryCalendarCount {
    date!: Date;
    messageCount!: number;
    readCount!: number;
    unreadCount!: number;

    constructor(data?: IDiaryCalendarCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.messageCount = _data["MessageCount"];
            this.readCount = _data["ReadCount"];
            this.unreadCount = _data["UnreadCount"];
        }
    }

    static fromJS(data: any): DiaryCalendarCount {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryCalendarCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["MessageCount"] = this.messageCount;
        data["ReadCount"] = this.readCount;
        data["UnreadCount"] = this.unreadCount;
        return data;
    }
}

export interface IDiaryCalendarCount {
    date: Date;
    messageCount: number;
    readCount: number;
    unreadCount: number;
}

export class SharedSessionModel implements ISharedSessionModel {
    userToken?: string | undefined;
    client?: string | undefined;
    product?: string | undefined;
    userId?: string | undefined;

    constructor(data?: ISharedSessionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToken = _data["UserToken"];
            this.client = _data["Client"];
            this.product = _data["Product"];
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): SharedSessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharedSessionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserToken"] = this.userToken;
        data["Client"] = this.client;
        data["Product"] = this.product;
        data["UserId"] = this.userId;
        return data;
    }
}

export interface ISharedSessionModel {
    userToken?: string | undefined;
    client?: string | undefined;
    product?: string | undefined;
    userId?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}